import React from 'react'
import { Typography } from './Typography'

export interface ListColumn {
  label: string
  flex?: number // flex-grow ratio
  align?: 'left' | 'center' | 'right'
  width?: string // e.g. '120px', '20%'
  className?: string
  headerClassName?: string
  cellClassName?: string
}

export interface ListProps {
  columns: ListColumn[]
  values: React.ReactNode[][]
  rowClassName?: string | ((row: React.ReactNode[], rowIdx: number) => string)
  headerClassName?: string
  bodyClassName?: string
  rowHeight?: string // e.g. '36px', '44px'
}

export const List: React.FC<ListProps> = ({
  columns,
  values,
  rowClassName,
  headerClassName = '',
  bodyClassName = '',
  rowHeight = '44px'
}) => {
  return (
    <div className='w-full'>
      {/* Header */}
      <div className={`flex w-full ${headerClassName}`}>
        {columns.map((col, idx) => (
          <div
            key={col.label}
            className={
              `h-[40px] flex items-center font-geistMono font-semibold text-tokens-neutral-text-secondary select-none ` +
              (col.className && col.className.includes('px-') ? col.className : 'px-4') +
              (col.headerClassName || '') +
              (col.align === 'left' || (!col.align && idx === 0)
                ? ' justify-start text-left'
                : col.align === 'right'
                  ? ' justify-end text-right'
                  : ' justify-center text-center')
            }
            style={{
              lineHeight: '40px',
              flex: col.flex ?? 1,
              width: col.width,
              minWidth: col.width
            }}
          >
            <Typography fontFamily='geistMono' fontSize='labelSm' fontWeight='semibold'>
              {col.label}
            </Typography>
          </div>
        ))}
      </div>
      {/* Body */}
      <div className={bodyClassName}>
        {values.map((row, rowIdx) => (
          <div
            key={rowIdx}
            className={
              'group flex rounded-[12px] transition-all duration-200 mb-1 overflow-hidden hover:bg-tokens-neutral-fill-fill-4 active:bg-tokens-neutral-fill-fill-6 ' +
              (typeof rowClassName === 'function' ? rowClassName(row, rowIdx) : rowClassName || '')
            }
            style={{ height: rowHeight }}
          >
            {columns.map((col, colIdx) => (
              <div
                key={col.label}
                className={
                  `flex items-center h-full overflow-hidden min-w-0 ` +
                  (col.cellClassName && col.cellClassName.includes('px-')
                    ? col.cellClassName
                    : 'px-4') +
                  (col.align === 'left' || (!col.align && colIdx === 0)
                    ? ' justify-start text-left'
                    : col.align === 'right'
                      ? ' justify-end text-right'
                      : ' justify-center text-center')
                }
                style={{
                  flex: col.flex ?? 1,
                  width: col.width,
                  minWidth: col.width,
                  minHeight: rowHeight,
                  verticalAlign: 'middle'
                }}
              >
                {row[colIdx]}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}
